export type SaveMode = 'auto' | 'manual';

export const SAVE_MODE_KEY = 'inazuma-manager-save-mode-v1';

export function readSaveMode(): SaveMode {
  try {
    return localStorage.getItem(SAVE_MODE_KEY) === 'manual' ? 'manual' : 'auto';
  } catch {
    return 'auto';
  }
}
